var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{attrs:{"type":"primary","aria-label":"search domain"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.$siteConfig.isMobile)?_c('AppIcon',{attrs:{"name":"search"}}):_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }